import { yupResolver } from "@hookform/resolvers/yup";
import { CategoryFieldSetsAPI, VariantsAPI } from "api";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import * as yup from "yup";
import VariantsBasicInformation from "./VariantsBasicInformation";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    options: yup.array().of(
      yup.object().shape({
        options: yup.array().of(yup.string()).required("Options is required"),
        name: yup.string().required("Name is required"),
        oiMapping: yup.string(),
        showImage: yup.boolean(),
        optionImagesPreview: yup.array().of(yup.string()),
        optionImages: yup.array().of(yup.string()),
      }),
    ),
    status: yup.boolean().required(),
  })
  .required();

const AddVariantsV1 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      options: [{}],
    },
  });
  const { handleSubmit, reset, setValue, setError, clearErrors } = methods;

  const onSubmit = async (data) => {
    // console.log(data);

    // let myData = {
    //   ...data,
    //   sortOrder: 0,
    //   id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    // };
    // myData.options = myData.options.map((variant) => {
    //   return {
    //     ...variant,
    //     optionImagesPreview: "",
    //     options: variant.options.join("|") ?? "", // Convert the array to a string
    //     optionImages: variant.optionImages
    //       ? variant.optionImages?.filter((image) => image != null).join("|")
    //       : "", // Convert the array to a string if it's an array
    //   };
    // });

    let myData = {
      ...data,
      sortOrder: 0,
      id: location?.state?.id ?? 0,
    };

    myData.options = myData.options.map((variant) => {
      const oiMap = variant.optionImageMap || {};

      // Convert mapping object → string
      const oiMappingString = Object.entries(oiMap)
        .filter(([_, value]) => value) // remove empty
        .map(([key, value]) => `${key}=${value}`)
        .join("|");

      return {
        ...variant,
        options: variant.options?.join("|") || "",
        optionImages: variant.optionImages?.join("|") || "",
        oiMapping: oiMappingString,
        optionImagesPreview: "", // backend doesn't need this
      };
    });

    console.log(myData);

    try {
      if (location?.state) {
        await VariantsAPI.post(myData);
        toast.success("Variant updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        await VariantsAPI.post(myData);
        toast.success("Variant created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (!location.state) return;

    const editData = { ...location.state };

    editData.options = editData.options.map((variant) => {
      // ✅ Convert oiMapping string → object
      let mappingObject = {};

      if (variant.oiMapping && typeof variant.oiMapping === "string") {
        variant.oiMapping.split("|").forEach((pair) => {
          const [key, value] = pair.split("=");
          if (key && value) {
            mappingObject[key] = value;
          }
        });
      }

      return {
        ...variant,
        optionImageMap: mappingObject, // <-- this is what UI uses
      };
    });

    reset(editData);
  }, [location.state, reset]);

  // useEffect(() => {
  //   if (location.state) {
  //     reset(location.state);
  //   }
  // }, []);

  return (
    <>
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}

      <PageTitle name="Libraries | Variants" />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <BreadCrumbTable
                    title="Libraries"
                    subTitle="Variants"
                    subSubTitle={location?.state?.name}
                  />
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    Libraries | Variants
                  </h5> */}
                </Col>
                <Col xs="auto" style={{ paddingRight: "15px" }}>
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <VariantsBasicInformation />
            {/* <Row className="">
            
              <Col lg={12}>
              </Col> */}
            {/* <Col xs={12}>
    
            </Col> */}
            {/* </Row> */}
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddVariantsV1;
